import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material/SvgIcon';

const AppsIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox='0 0 24 24' {...props}>
    <path
      d='M3 3.75C3 3.33579 3.33579 3 3.75 3H6.75C7.16421 3 7.5 3.33579 7.5 3.75V6.75C7.5 7.16421 7.16421 7.5 6.75 7.5H3.75C3.33579 7.5 3 7.16421 3 6.75V3.75Z'
      fill='currentColor'
    />
    <path
      d='M3 10.5C3 10.0858 3.33579 9.75 3.75 9.75H6.75C7.16421 9.75 7.5 10.0858 7.5 10.5V13.5C7.5 13.9142 7.16421 14.25 6.75 14.25H3.75C3.33579 14.25 3 13.9142 3 13.5V10.5Z'
      fill='currentColor'
    />
    <path
      d='M9.75 10.5C9.75 10.0858 10.0858 9.75 10.5 9.75H13.5C13.9142 9.75 14.25 10.0858 14.25 10.5V13.5C14.25 13.9142 13.9142 14.25 13.5 14.25H10.5C10.0858 14.25 9.75 13.9142 9.75 13.5V10.5Z'
      fill='currentColor'
    />
    <path
      d='M16.5 10.5C16.5 10.0858 16.8358 9.75 17.25 9.75H20.25C20.6642 9.75 21 10.0858 21 10.5V13.5C21 13.9142 20.6642 14.25 20.25 14.25H17.25C16.8358 14.25 16.5 13.9142 16.5 13.5V10.5Z'
      fill='currentColor'
    />
    <path
      d='M3 17.25C3 16.8358 3.33579 16.5 3.75 16.5H6.75C7.16421 16.5 7.5 16.8358 7.5 17.25V20.25C7.5 20.6642 7.16421 21 6.75 21H3.75C3.33579 21 3 20.6642 3 20.25V17.25Z'
      fill='currentColor'
    />
    <path
      d='M9.75 17.25C9.75 16.8358 10.0858 16.5 10.5 16.5H13.5C13.9142 16.5 14.25 16.8358 14.25 17.25V20.25C14.25 20.6642 13.9142 21 13.5 21H10.5C10.0858 21 9.75 20.6642 9.75 20.25V17.25Z'
      fill='currentColor'
    />
    <path
      d='M16.5 17.25C16.5 16.8358 16.8358 16.5 17.25 16.5H20.25C20.6642 16.5 21 16.8358 21 17.25V20.25C21 20.6642 20.6642 21 20.25 21H17.25C16.8358 21 16.5 20.6642 16.5 20.25V17.25Z'
      fill='currentColor'
    />
    <path
      d='M9.75 3.75C9.75 3.33579 10.0858 3 10.5 3H13.5C13.9142 3 14.25 3.33579 14.25 3.75V6.75C14.25 7.16421 13.9142 7.5 13.5 7.5H10.5C10.0858 7.5 9.75 7.16421 9.75 6.75V3.75Z'
      fill='currentColor'
    />
    <path
      d='M16.5 3.75C16.5 3.33579 16.8358 3 17.25 3H20.25C20.6642 3 21 3.33579 21 3.75V6.75C21 7.16421 20.6642 7.5 20.25 7.5H17.25C16.8358 7.5 16.5 7.16421 16.5 6.75V3.75Z'
      fill='currentColor'
    />
  </SvgIcon>
);

export default AppsIcon;
